import { render, staticRenderFns } from "./tab-device-filter.vue?vue&type=template&id=0a0a5701"
import script from "./tab-device-filter.vue?vue&type=script&lang=js"
export * from "./tab-device-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports